export type Comparationfilters = {
	label: string;
	id: string
}

export function getComparationFilters() {
	return [
		{label: "Alguma divergência", id: "SOME"},
		{label: "Não está no eSocial", id: "ESOCIAL"},
		{label: "Nome divergente", id: "NAME"},
		{label: "Cargo divergente", id: "CARGO"},
		{label: "CPF divergente", id: "CPF"},
		{label: "Data de admissão divergente", id: "ADMISSION"},
		{label: "Data de desligamento divergente", id: "OFF"},
		{label: "Data de nascimento divergente", id: "BIRTHDAY"},
		{label: "CBO divergente", id: "CBO"},
		{label: "Local de trabalho divergente", id: "WORKSPACE"},
		{label: "Matrícula divergente", id: "MATRICULA"},
		{label: "Situação divergente", id: "SITUATION"},
		{label: "Admissão preliminar", id: "PRELIMINAR"},
		{label: "Ver todos os funcionários", id: "ALL"}
	] as Comparationfilters[]
}

export function getComparationEventsFilters() {
	return [
		{label: "Alguma divergência", id: "SOME"},
		{label: "Erro em 2210", id: "2210"},
		{label: "Erro em 2220", id: "2220"},
		{label: "Erro em 2240", id: "2240"},
		{label: "Não está no eSocial", id: "ESOCIAL"},
		{label: "Admissão preliminar", id: "PRELIMINAR"},
		{label: "Ver todos os funcionários", id: "ALL"}
	] as Comparationfilters[]
}

export function getDeliveryDateFilters() {
	return [
		{label: "Todas", id: "ALL"},
		{label: "Enviados neste mês", id: "THIS_MONTH"},
		{label: "Enviados nos últimos 30 dias", id: "LAST_30"},
		{label: "Enviados nos últimos 3 meses", id: "LAST_90"},
		{label: "Enviados neste ano", id: "THIS_YEAR"},
		{label: "Personalizado", id: "CUSTOMIZED"},
	] as Comparationfilters[]
}